import React, { FC, useState } from "react";
import useOutsideClick from "hooks/click-outside";
import pinImage from "assets/images/svgs/ambassador/Learn-Local-Pin.svg";
import giftCardImage from "assets/images/svgs/ambassador/$5 Gift Card.svg";
import notebookImage from "assets/images/svgs/ambassador/Notebook or Journel.svg";
import toteBagImage from "assets/images/svgs/ambassador/Totel Bag.svg";
import waterBottleImage from "assets/images/svgs/ambassador/Water Bottle.svg";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface CheckoutPopupProps {
  isOpen: boolean;
  handleConfirm: () => void;
  onClose: () => void;
  data: any
}

const Checkoutpoppup: FC<CheckoutPopupProps> = ({ isOpen, onClose, handleConfirm, data }) => {
  const modalRef = useOutsideClick(onClose);
  console.log(data, 'data');


  if (!isOpen) return null;

  return (
    <>
      <div className="fixed  inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300"
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
      >
        <div
          ref={modalRef}
          className="relative bg-white px-6 py-8 rounded-xl shadow-lg w-[90%] sm:w-[50%] md:w-[40%] lg:w-[30%] xl:w-[20%] transform scale-100 transition-transform duration-300"
        >
          <button
            onClick={onClose}
            className="absolute top-3 right-3  w-8 h-8 flex items-center justify-center bg-transparent"
          >
            ✕
          </button>
          <div className="flex justify-center items-center mt-5 gap-2 mb-6">
            {data
              ?.filter((item) => item.quantity > 0)
              .slice(0, 5)
              .map((item, i) => (
                <div key={i} className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow">
                  <img
                    src={concatPathWithBackendUrl(item.image.name)}
                    alt={item.itemName}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}

            {/* Show +N if there are more than 5 */}
            {data?.filter((item) => item.quantity > 0).length > 5 && (
              <div className="w-12 h-12 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center border-2 border-white text-sm font-medium shadow">
                +
                {data.filter((item) => item.quantity > 0).length - 5}
              </div>
            )}
          </div>

     

          <h2 className="text-xl font-bold text-center mb-4 text-black">
            Confirm your Redeem!
          </h2>
          <p className="text-center text-gray-700 mb-6">
            Confirm your Product by Redeem Prize Points, Click Confirm or Cancel to Discard.
          </p>

          <div className="mt-6 flex justify-center space-x-4">
            <button
              onClick={onClose}
              className="bg-fade text-ambassadorBlue px-6 py-2 rounded-full font-semibold"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="bg-ambassadorBlue text-white px-6 py-2 rounded-full font-semibold"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default Checkoutpoppup;
